import React from "react";

export default function GeneralSettingsForm({ 
  formData, 
  errors, 
  handleChange,
  disabled
}) {
  return (
    <>
      <div className="form-group">
        <label htmlFor="company_name">Razón Social *</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          className={`form-control ${errors.company_name && "is-invalid"}`}
          value={formData.company_name}
          onChange={handleChange}
          disabled={disabled}
          required
        />
        {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="fantasy_name">Nombre de Fantasía</label>
        <input
          type="text"
          id="fantasy_name"
          name="fantasy_name"
          className={`form-control ${errors.fantasy_name && "is-invalid"}`}
          value={formData.fantasy_name}
          onChange={handleChange}
          disabled={disabled}
        />
        {errors.fantasy_name && <div className="invalid-feedback">{errors.fantasy_name}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="business_address">Domicilio Comercial *</label>
        <input
          type="text"
          id="business_address"
          name="business_address"
          className={`form-control ${errors.business_address && "is-invalid"}`}
          value={formData.business_address}
          onChange={handleChange}
          disabled={disabled}
          required
        />
        {errors.business_address && <div className="invalid-feedback">{errors.business_address}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="activity_start_date">Inicio de Actividades *</label>
        <input
          type="date"
          id="activity_start_date"
          name="activity_start_date"
          className={`form-control ${errors.activity_start_date && "is-invalid"}`}
          value={formData.activity_start_date}
          onChange={handleChange}
          disabled={disabled}
          required
        />
        {errors.activity_start_date && <div className="invalid-feedback">{errors.activity_start_date}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="fiscal_position">Condición Frente al IVA *</label>
        <select
          id="fiscal_position"
          name="fiscal_position"
          className={`custom-select ${errors.fiscal_position && "is-invalid"}`}
          value={formData.fiscal_position}
          onChange={handleChange}
          disabled={disabled}
          required
        >
          <option value="6">Monotributo</option>
        </select>
        {errors.fiscal_position && <div className="invalid-feedback">{errors.fiscal_position}</div>}
      </div>
      <div className="form-group">
        <label htmlFor="iibb">Ingresos Brutos *</label>
        <input
          type="text"
          id="iibb"
          name="iibb"
          className={`form-control ${errors.iibb && "is-invalid"}`}
          value={formData.iibb}
          onChange={handleChange}
          disabled={disabled}
          required
        />
        {errors.iibb && <div className="invalid-feedback">{errors.iibb}</div>}
      </div>
    </>
  );
}
